var map = {
	"./advice.json": 15455,
	"./placeholder_example_of_use.json": 26424,
	"./pss_report.json": 37154,
	"./service_report.json": 16756,
	"./survey_epe.json": 2064,
	"./survey_project.json": 80694,
	"./survey_project_advice.json": 6860,
	"./survey_project_meeting.json": 19164,
	"./survey_project_pss.json": 36680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36177;